<template>
    <div class="actions-div">
        <prime-button @click="handleClick" :disabled="isEmailSent" variant="secondary" class="p-btn-root_secondary w-full">
            Email Gift Certificate
        </prime-button>
        <PrimeButton @click="handleCopyClick" variant="secondary" class="p-btn-root_secondary copy-btn"
            >Copy Code to Clipboard</PrimeButton
        >
    </div>
</template>
<script setup lang="ts">
import { useSubscribeStore } from '@/stores/components/modals/subscription-modal';
import PrimeButton from 'primevue/button';
import { useBillingStore } from '~/stores/person/billing';
import { inject, type Ref } from 'vue';

const store = useSubscribeStore();

const props = defineProps({
  isEmailSent: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['handleEmailClick', 'handleCopyCode']);

const giftCertActionTaken = inject<Ref<boolean>>('giftCertActionTaken');

const handleClick = async () => {
  if (giftCertActionTaken) giftCertActionTaken.value = true;
  try {
    const giftCertCode = store.giftCertCode;
    const giftCertEmail = store.giftCertEmail;
    const giftCertName = store.giftCertName;
    
    if (giftCertCode && giftCertEmail && giftCertName) {
      const billingStore = useBillingStore();
      await billingStore.sendGiftCertificateEmail(giftCertName, giftCertEmail, giftCertCode);

      await navigator.clipboard.writeText(giftCertCode);
      emit('handleEmailClick');
    } else {
      console.error('Missing gift certificate details for email');
    }
  } catch (error) {
    console.error('Failed to send gift certificate email:', error);
  }
};

const handleCopyClick = async () => {
  if (giftCertActionTaken) giftCertActionTaken.value = true;
  emit('handleCopyCode');
  try {
    const giftCertCode = store.giftCertCode;
    if (giftCertCode) {
      await navigator.clipboard.writeText(giftCertCode);
    }
  } catch (error) {
    console.error('Failed to copy to clipboard:', error);
  }
};
</script>
<style lang="scss" scoped>
.actions-div {
    @apply flex justify-end items-center gap-3 self-stretch;
}

.copy-btn {
    @apply focus:border-white-700 focus:outline-none focus:ring-1 focus:ring-blue-700 w-full;
}
</style>